import { createFileRoute, redirect } from "@tanstack/react-router";

// Moved to consignment-request. The old id is a consignment_vendor_registration id,
// not a registration id, so it cannot open a registration detail; land on Requests.
export const Route = createFileRoute(
	"/admin/consignment-vendor-registration/$id",
)({
	beforeLoad() {
		throw redirect({ to: "/admin/consignment-request", replace: true });
	},
});
